import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { message } from 'antd';

const HookFormErrorFocus: React.FC = () => {
  const { formState } = useFormContext();
  const { errors, isSubmitting } = formState;

  useEffect(() => {
    const errorKeys = Object.keys(errors);
    if (isSubmitting && errorKeys.length > 0) {
      const firstErrorKey = errorKeys[0];
      const selector = `[name="${firstErrorKey}"]`;
      const errorElement = document.querySelector(selector);

      if (errorElement) {
        (errorElement as HTMLElement).focus({ preventScroll: true });
        errorElement.scrollIntoView({ block: 'end', behavior: 'smooth' });
        message.error('An error occurred. Please check your form inputs.');
      }
    }
  }, [errors, isSubmitting]);

  return null;
};

export default HookFormErrorFocus;
